var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"maintenance"},[_c('h1',[_vm._v(" Website đang bảo trì, vui lòng đợi trong giây lát. ")])])])
}]

export { render, staticRenderFns }